:host ion-chip {
    position: relative;
    margin-top: 2px;
    margin-left: 0px;
    padding-left: 10px !important;
    padding-right: 10px !important;
    background-color: rgb(245, 247, 255);
    cursor: default;
}

:host .lang-chip-icon {
    font-size: 20px;
    line-height: 10px;
}

:host ion-label {
    font-size: 0.7em;
    padding-left: 0.7vw;
}
